module.exports = __webpack_public_path__ + "img/list-ul.49147fc9.svg";